import type { FaireProductEntity } from "../../entity_types/product";

export const p_4eg3yg4jgd: FaireProductEntity = {
  token: "p_4eg3yg4jgd",
  type: "product",
  name: "Hermitage Luxury Scented Candle",
  brandToken: "b_rp9e5zdxjc",
  brandName: "Wilkin & May",
  imageUrl:
    "https://cdn.faire.com/fastly/96540ef7dbf19e00bb710b1e323f0cf43338e77d0e922b6eca66d57c157a3d7f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/21d94277b1b1d642efcc52b97891991e18f111b9109845584936e9419c97f25f.png",
    "https://cdn.faire.com/fastly/8c7d43ae4f4958b90f1b3e42b22c56cf0f8e505f46ca88abe2f78397d7b4108c.jpeg",
    "https://cdn.faire.com/fastly/82e1239e021d21ecb5b6dab5e0ff8b2ae85a58c8f474d74ee66ec4acf9907d92.jpeg",
    "https://cdn.faire.com/fastly/84fe5648d1cdf6e295f3a5983fcccd9df9f1983b9e46645a7afc573cbce73f91.jpeg",
  ],
  priceDollars: 24,
  description:
    "Refined, coastal, and effortlessly sensual. \n\nSun-warmed pomelo and salt-kissed air open the fragrance with bright, breezy clarity, softened by the delicate bloom of garden peony. Beneath it, black saffron, driftwood, and piñon smolder quietly—evoking antique wood, steeped tea, and open windows on a serene morning. \n\nA scent that feels lush yet restrained, turning presence itself into a form of beauty. \n\nEvery detail is designed to feel intentional: hand-poured in small batches, a clean coconut wax blend for an elegant burn, and a vessel meant to live on long after the flame. Even the wax itself is skin-safe, melting into a balm you can carry beyond the room.\n\nDetails:\n\n- Hand-poured in Ojai, California in small batches\n- Clean-burning coconut wax blend\n- Skin-safe wax doubles as a nourishing balm\n- 40+ hour burn time\n- Lead-free cotton wick\n- Reusable glass vessel\n- Phthalate-free, paraben-free and cruelty-free\n- Sustainable, biodegradable wax and packaging\n- Fragrance oils infused with natural botanicals\n- Ideal for hotel boutiques, coastal home stores, spa retail, gift shops and luxury home fragrance displays\n\nLuxury positioning: coastal, refined, boutique, sensual and gift-worthy.",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:13.618Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
